<template>
  <!-- Componente ApexChart para gráfico de barras horizontais -->
  <apexchart type="bar" :options="chartOptions" :series="seriesData" />
</template>

<script setup>
/* global defineProps */
import { computed, watch } from 'vue';
import apexchart from 'vue3-apexcharts';

// Define as props que o componente recebe: 
// "data" deve ser um array de objetos com as chaves "name" e "nota"
const props = defineProps({
  data: {
    type: Array,
    default: () => []
  },
  refreshKey: {
    type: Number,
    default: 0
  }
});
// Cria a série de dados: cada data point contém "x" (nome do participante) e "y" (nota)
// Os dados são ordenados do maior para o menor (pela nota)
const seriesData = computed(() => {
  const rawData = JSON.parse(JSON.stringify(props.data)) || [];
  const sorted = rawData.sort((a, b) => Number(b.nota) - Number(a.nota));
  return [{
    name: 'Nota',
    data: sorted.map(item => ({
      x: item.name,
      y: Number(item.nota) || 0
    }))
  }];
});

// Define as categorias (nomes dos participantes)
const chartCategories = computed(() => {
  const rawData = JSON.parse(JSON.stringify(props.data)) || [];
  const sorted = rawData.sort((a, b) => Number(b.nota) - Number(a.nota));
  return sorted.map(item => item.name);
});


// Configura as opções do gráfico
const chartOptions = computed(() => ({
  chart: {
    type: 'bar',
    toolbar: { show: false }
  },
  plotOptions: {
    bar: {
      horizontal: true,
      barHeight: '70%',
      distributed: true
    }
  },
  xaxis: {
    title: { text: 'Nota' },
    min: 0,
    max: 10 // Limita a escala para evitar barras excessivamente largas
  },
  yaxis: {
    title: { text: 'Participantes' },
    categories: chartCategories.value,
    labels: {
      show: true
    }
  },
  dataLabels: {
    enabled: true
  },
  tooltip: {
    enabled: true
  }
}));

// Watchers para forçar a atualização quando os dados ou o refreshKey mudarem
watch(() => props.data, () => {
  // As computadas se atualizam automaticamente
}, { deep: true });
watch(() => props.refreshKey, () => { });
</script>

<style scoped>
/* Você pode adicionar estilos personalizados, se necessário */
</style>
